<template>
  <li class="relative border-b border-neutral-300/70 my-1">
    <button type="button" class="w-full py-2 text-left" @click="selected = !selected">
      <div class="flex items-center justify-between px-2 ">
        <span class="font-medium text-sm text-neutral-700 hover:text-support-700">{{ accordion.title }}</span>
        <ChevronUpIcon v-if="selected" :size="20" />
        <ChevronDownIcon v-else :size="20" />
      </div>
    </button>

    <transition name="slide">
      <div v-show="selected" class="relative overflow-hidden transition-all duration-700 px-2" style="">
        <div class="py-2">
          <div class="text-sm text-neutral-600 tracking-wide leading-relaxed" v-html="accordion.description"> </div>
        </div>
      </div>
    </transition>
  </li>
</template>
<script>
export default {
  name: 'BaseAccordion',
  props: {
    accordion: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selected: false,
    }
  },
}
</script>
